import * as React from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import Divider from '@mui/material/Divider';
import UploadImagesSection from '../../Components/HomePageWebsite/UploadImagesSection';


///////////////////// Components
import InputsFieldsSectionTwo from '../../Components/HomePageWebsite/InputsFieldsSectionTwo';
import InputsFieldsSectionThree from '../../Components/HomePageWebsite/InputsFieldsSectionThree';


export default function HomePageWebsite() {

    return (
        <>
            <h2>القسم الثاني</h2>
            <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={6}>
                    <InputsFieldsSectionTwo/>
                </Grid>
                <Grid xs={6}>

                    <UploadImagesSection />

                </Grid>
            </Grid>
            
            <Divider sx={{ margin: '50px 0' }} />

            <h2>القسم الثالث</h2>
            <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={12}>
                    <InputsFieldsSectionThree/>
                </Grid>
            </Grid>
        </>
    );
}